export const articles = [
    {
        title: "Title",
    }
]

export default articles;